import { createSelector } from '@ngrx/store';

import {
  getIsDescendant,
  getIsGrandchild,
  getRelationshipDesignation,
} from '../../reducers/beneficiaries/beneficiaries.reducer';
import * as fromFeature from '../../reducers/index';

export const selectBeneficiaryState = createSelector(
  fromFeature.getBeneficiariesState,
  (state) => state,
);

export const selectRelationshipDesignation = createSelector(
  fromFeature.getBeneficiariesState,
  getRelationshipDesignation,
);
export const selectIsDescendant = createSelector(
  fromFeature.getBeneficiariesState,
  getIsDescendant,
);
export const selectIsGrandchild = createSelector(
  fromFeature.getBeneficiariesState,
  getIsGrandchild,
);
